import { isArray } from "ArrayUtils";
import { type DependencyResult, getAvailableResult } from "DependencyResult";
import type { DependencyAccessValue, DependencyArgument, DependencyVisitorContext } from "DependencyVisitorContext";
import { decoratedWaitAvailable, operationTypes } from "DependencyVisitorUtils";
import { DependencyError } from "Errors";

const containsDecorationInfo = Object.freeze({
  operationType: operationTypes.Method,
  operandCount: 2,
  booleanResult: true,
});

function contains<Mode>(
  enumerable: DependencyArgument,
  searchElement: DependencyArgument,
  data: unknown,
  context: DependencyVisitorContext<Mode>,
): DependencyAccessValue<Mode, boolean> {
  return decoratedWaitAvailable([enumerable, searchElement], data, context, containsCore, containsDecorationInfo);
}

function containsCore([enumerable, searchElement]: unknown[]): DependencyResult<boolean> {
  if (enumerable == null) {
    return getAvailableResult(false);
  } else if (isArray(searchElement)) {
    throw new DependencyError("The argument for Contains() must be a scalar value.");
  } else if (typeof enumerable === "string") {
    return getAvailableResult(typeof searchElement === "string" && enumerable.includes(searchElement));
  } else if (isArray(enumerable)) {
    return getAvailableResult(enumerable.includes(searchElement));
  } else {
    throw new DependencyError("Contains() can only be used on a collection or string.");
  }
}

export default { contains };
